<template>
  <template v-if="pageList == 'maintainstatusnow'">
    <!-- 即時維修狀態 -->
    <maintainStatusNow></maintainStatusNow>
  </template>
  <template v-else-if="pageList == 'maintainlog'">
    <!-- 維修履歷 -->
    <maintainLog></maintainLog>
  </template>
  <template v-else-if="pageList == 'alarmhistory'">
    <!-- 警報履歷 -->
    <alarmHistory></alarmHistory>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import maintainStatusNow from "@/components/errorHistory/maintainStatusNow";
import maintainLog from "@/components/errorHistory/maintainLog";
import alarmHistory from "@/components/errorHistory/alarmHistory";
export default {
  components: {
    maintainStatusNow,
    maintainLog,
    alarmHistory,
  },
  setup() {
    const store = useStore();

    //getters
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );

    const pageList = ref();
    const pageListChild = ref();

    //function
    const setSessionItems = () => {
      sessionStorage.setItem("mes-errorHistory-pageList", pageList.value);
      sessionStorage.setItem(
        "mes-errorHistory-pageListChild",
        pageListChild.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    watch(sideBarSelect, (newValue) => {
      pageList.value = newValue.pageList;
      pageListChild.value = newValue.pageListChild;
    });

    setTimeout(() => {
      pageList.value = sideBarSelect.value.pageList;
      pageListChild.value = sideBarSelect.value.pageListChild;

      //session資料
      const mesErrorHistoryPageList = sessionStorage.getItem(
        "mes-errorHistory-pageList"
      );
      const mesErrorHistoryPageListChild = sessionStorage.getItem(
        "mes-errorHistory-pageListChild"
      );
      sessionStorage.removeItem("mes-errorHistory-pageList");
      sessionStorage.removeItem("mes-errorHistory-pageListChild");
      if (mesErrorHistoryPageList != null) {
        pageList.value = mesErrorHistoryPageList;
      }
      if (mesErrorHistoryPageListChild != null) {
        pageListChild.value = mesErrorHistoryPageListChild;
      }
    }, 0);

    provide("pageList", pageList);
    provide("pageListChild", pageListChild);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });

    return { pageList };
  },
};
</script>

<style></style>
<style lang="scss"></style>
